import React from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { MdOutlineEmail, MdArrowDownward } from 'react-icons/md';
import { Typewriter } from 'react-simple-typewriter';
import CustomCursor from '../CustomCursor';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import OrbitingSkills from './OrbitingSkills';
import myImage from '../images/IMG_1243.png';

function HeroSection() {
  return (
    <>
      <CustomCursor />
      <section className="hero-section">
        

        <div className="hero-background">
          <OrbitingSkills />
        </div>

        <div className="hero-glass-container">
          <ScrollEffectWrapper>
            <div className="hero-image-container modern-glow">
              <img src={myImage} alt="Tyler" className="hero-image" />
              <div className="hero-image-glow" />
            </div>
          </ScrollEffectWrapper>

          <ScrollEffectWrapper delay={200}>
            <h1 className="hero-title">
              Hi, I'm <span className="hero-name-gradient">Tyler</span>
            </h1>
          </ScrollEffectWrapper>

          <ScrollEffectWrapper delay={400}>
            <h2 className="hero-subtitle">
              <span className="static-text">I'm a </span>
              <span className="typing-text">
                <Typewriter
                  words={['Mobile & Web Application Major', 'Information Assurance/Cyber Defense Minor', 'Tech Enthusiast', 'Avid Gamer']}
                  loop={0}
                  cursor
                  cursorStyle="_"
                  typeSpeed={150}
                  deleteSpeed={100}
                  delaySpeed={2000}
                />
              </span>
            </h2>
          </ScrollEffectWrapper>

          <ScrollEffectWrapper delay={600}>
            <p className="hero-description">
              Currently pursuing my Mobile & Web Application degree w/ Concentration in Information Assurance/Cyber Defense at Northern Michigan University.
            </p>
          </ScrollEffectWrapper>

          <ScrollEffectWrapper delay={800}>
            <div className="hero-buttons modern-buttons">
              <a href="https://www.linkedin.com/in/tlm99" target="_blank" rel="noreferrer" className="btn btn-glow btn-connect">
                <FaLinkedin /> Let's Connect
              </a>
              <a href="https://github.com/Thymester" target="_blank" rel="noreferrer" className="btn btn-outline-glow">
                <FaGithub /> GitHub
              </a>
              <a href="mailto:tylerdev@tylerthedev.xyz" className="btn btn-icon" title="Email Me">
                <MdOutlineEmail size={24} />
              </a>
            </div>
          </ScrollEffectWrapper>
        </div>
        
        <div className="scroll-indicator" onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}>
          <MdArrowDownward size={32} className="bounce-animation" />
        </div>
      </section>
    </>
  );
}

export default HeroSection;
